import React from "react";
import { useSettings } from '../components/SettingsContext'
import { Helmet } from "react-helmet";

export default function CookiesPolicy() {
  const { settings, loading } = useSettings();

  if (loading) return <div>Loading...</div>;

  return (
    <>
    <Helmet>
        <title>Cookie Policy</title>
    </Helmet>
    <div>
      {/* Page Title Section */}
      <section className="page-title-area sky-blue-bg pt-160 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="page-title-wrapper text-center">
                <h4 className="styled-text theme-color mb-30">Understanding Cookies</h4>
                <h5 className="h1 page-title">Cookies Policy</h5>
                <p className="mb-4">
                  We use cookies to enhance your experience and improve our services. This policy explains what cookies are and how we use them.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cookies Policy Content */}
      <section className="cookies-policy-area py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div
                className="policy-content"
                dangerouslySetInnerHTML={{ __html: settings?.cookie_policy }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
